import BrandsSubscriptionsStore from '../store/schema/BrandsSubscriptionsStore';
import getStore from '../store/store';
import { mutator } from 'satcheljs';
import { updateBrandsSubscriptions } from '../actions/internalActions';

export default mutator(updateBrandsSubscriptions, actionMessage => {
    const brandsSubscriptionsStore: BrandsSubscriptionsStore = getStore();

    // Filter the subscriptions that are from blocked senders
    brandsSubscriptionsStore.subscriptions = actionMessage.response.subscriptions.filter(
        subscriptionModel => {
            return !actionMessage.blockedSendersMap[
                subscriptionModel.smtpInfo.smtpAddress.toLowerCase()
            ];
        }
    );

    // Filter the unsubscribed subscriptions that are from blocked senders
    brandsSubscriptionsStore.unsubscribedSubscriptions = actionMessage.response.unsubscribedSubscriptions.filter(
        subscriptionModel => {
            return !actionMessage.blockedSendersMap[
                subscriptionModel.smtpInfo.smtpAddress.toLowerCase()
            ];
        }
    );
});
